const state = {
    me: null,
    hourAppUser: null,
    users:[]
}

export default state
